module.exports = __webpack_public_path__ + "1ae5b1ffa0a1334a78473ebd8f093bc4.pdf";